import { defineStore } from "pinia";
import { USER_TYPE } from "/constants/common.js";

export const useBaseStore = defineStore("base", () => {
  const config = useRuntimeConfig();
  const adminMode = config.public.isAdmin;
  const serverEnv = config.public.server;
  const nodeEnv = config.public.nodeEnv
  const failToRefreshToken = ref(false);
  const refreshToken = ref(false);
  const isAuthenticated = ref(false);
  const hideHeader = ref(true);
  const showSpinner = ref(false);
  const user = ref({});
  const urlNav = ref(null);
  const apexPreviewPage = ref(false)
  const continents = ref([])
  const countries = ref([])
  const customLocale = ref(null)
  const enquiries = ref([])
  const localeLanguages = ref({
    en: null,
    zh: null,
    ja: null
  })
  const modalKey = ref(0)
  const locales = ref(['en', 'zh', 'ja'])
  const userChecked = ref(false)
  const apiCache = ref({})
  const currentPage = ref(null)
  const notifications = ref([])
  const fullErrorPage = ref(false)
  const rememberMe = ref(false)
  const rememberedId = ref('')

  const setDypBodyToTop = () => {
    window &&
      setTimeout(() => {
        window.scroll({
          top: 0,
          left: 0
        })
      })
  }

  const toggleRememberMe = (value) => {
    rememberMe.value = value;
    localStorage.setItem("rememberMe", JSON.stringify(value));
  }

  const getEnquiries = async ({ text }, locale) => {
    if (enquiries.value.length) return
    const result = await usePost('/code/q/a/', { mcdId: 109, locale })
    const data = result.data.data.map(({ codeId, codeName }) => {
      return {
          value: codeId,
          text: codeName
      }
    })
    enquiries.value = [text ? { value: null, text } : null].concat(data).filter(n => n)
  }

  const getUserMeUrl = () => {
    return adminMode ? "/admin/me" : "/user/me";
  }

  const getUserMe = async () => {
    const result = await usePost(getUserMeUrl())
    user.value = result.data.data
    return result.data.data
  }

  const getUserType = (userType) => {
    return adminMode ? USER_TYPE.ADMIN : userType;
  }

  // change showSpinner to setSpinner function
  const setSpinner = () => {
    showSpinner.value = true
  }

  const hideSpinner = () => {
    showSpinner.value = false
  }

  const getLanguagesByCode = async (target) => {
    const result = await useGet(`/locale/${target}`)
    return result.data
  }
  
  const updateModalKey = () => {
    modalKey.value++
  }

  const getCountries = (optionalOption) => {
    const list = Array.isArray(countries.value) ? countries.value : []
    return [
      optionalOption,
      ...list
        .slice()
        .filter(n => n)
        .sort((a, b) => a.text.localeCompare(b.text))
    ]
  }
  
  const disableAllCountries = (value) => {
    continents.value.map(continent => {
      return {
        ...continent,
        countries: continent.countries.map(country => {
          country.disabled = value
          return country
        })
      }
    })
  }
  
  const getContinents = async (allLabel, locale) => {
    if( continents.value.length) {
      return
    }
    const data  = await usePost('/continent/q/a', { locale })
    const result = await Promise.all(
      data.data.data.map(async ({ continentCode }) => {
        const {
          data: { data: countries }
        } = await usePost(
          '/continent/q/user',
          {
            locale,
            continentCode
          }
        )
        return [
          { text: allLabel, value: 0 },
          ...countries.map(country => {
            return {
              ...country,
              text: country.countryName,
              value: country.countryCode
            }
          })
        ]
      })
    )
    continents.value = data.data.data.map((continent, index) => {
      return {
        ...continent,
        countries: result[index]
      }
    })
  }

  const fetchCountries = async (locale) => {
    const list = Array.isArray(countries.value) ? countries.value : []
    if (list.length) return
  
    countries.value = [{ value: null, text: '' }]
    const {
      data: { data }
    } = await usePost(
      '/country/q/a',
      {
        countryName: '%',
        locale
      }
    )
    const result = data.map(({ iso, countryName }) => ({
      value: iso,
      text: countryName
    }))
    countries.value = result
    return result
  }

  const addNotification = (notification) => {
    notifications.value.push(notification)
  }
  
  const createYBSession = async (params) => {
    try {
      const result =  await usePost(`/user/cs`, params)
      return result.data
    } catch (error) {
      console.error("Error creating YB session:", error);
      throw error;
    }
  }

  return {
    apexPreviewPage,
    continents,
    countries,
    customLocale,
    enquiries,
    adminMode,
    isAuthenticated,
    urlNav,
    serverEnv,
    failToRefreshToken,
    refreshToken,
    showSpinner,
    userChecked,
    hideHeader,
    localeLanguages,
    locales,
    modalKey,
    apiCache,
    currentPage,
    notifications,
    fullErrorPage,
    nodeEnv,
    rememberMe,
    rememberedId,
    user,
    setDypBodyToTop,
    fetchCountries,
    getEnquiries,
    getUserMe,
    getUserType,
    setSpinner,
    hideSpinner,
    getLanguagesByCode,
    getCountries,
    updateModalKey,
    disableAllCountries,
    getContinents,
    addNotification,
    getUserMeUrl,
    createYBSession,
    toggleRememberMe
  }
});
